import React from "react";

import { Button, Menu, MenuItem, Stack } from "@mui/material";

import DownloadIcon from "@mui/icons-material/Download";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

/**
 * The combined PDF stays in front. Upper and lower files stay available under More.
 */
export default function ExaminationExportBar({ label, isExporting, onExportPdf, onUpperPng, onUpperPdf, onLowerPng, onLowerPdf }) {
    const [anchor, setAnchor] = React.useState(null);

    const close = () => setAnchor(null);

    const choose = (action) => {
        close();
        action?.();
    };

    return (
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" justifyContent="center" alignItems="center">
            <Button variant="contained" color="success" startIcon={<DownloadIcon />} onClick={onExportPdf} disabled={isExporting}>
                {label}
            </Button>
            <Button variant="outlined" endIcon={<ArrowDropDownIcon />} onClick={(event) => setAnchor(event.currentTarget)} disabled={isExporting}>
                More
            </Button>
            <Menu
                anchorEl={anchor}
                open={Boolean(anchor)}
                onClose={close}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}>
                <MenuItem onClick={() => choose(onUpperPng)}>Upper PNG</MenuItem>
                <MenuItem onClick={() => choose(onUpperPdf)}>Upper PDF</MenuItem>
                <MenuItem onClick={() => choose(onLowerPng)}>Lower PNG</MenuItem>
                <MenuItem onClick={() => choose(onLowerPdf)}>Lower PDF</MenuItem>
            </Menu>
        </Stack>
    );
}
